import React from "react";

function MenuClose() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="19"
            fill="none"
            viewBox="0 0 48 19"
        >
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M8.85 1.296a1.1 1.1 0 01.054 1.555L2.604 9.6l6.3 6.75a1.1 1.1 0 01-1.608 1.5l-7-7.5a1.1 1.1 0 010-1.5l7-7.5a1.1 1.1 0 011.555-.054zM16 1.1A1.1 1.1 0 0117.1 0h29a1.1 1.1 0 010 2.2h-29A1.1 1.1 0 0116 1.1zM16 9.7a1.1 1.1 0 011.1-1.1h29a1.1 1.1 0 010 2.2h-29A1.1 1.1 0 0116 9.7zM16 17.7a1.1 1.1 0 011.1-1.1h29a1.1 1.1 0 010 2.2h-29a1.1 1.1 0 01-1.1-1.1z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default MenuClose;
